export default __webpack_public_path__ + "static/media/programming (2).4001d030.jpg";